import { SvgIcon, SvgIconProps } from '@mui/material';

export const BarcodeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M1 3H6V5H3V8H1V3ZM18 3H23V8H21V5H18V3ZM21 19V16H23V21H18V19H21ZM3 16V19H6V21H1V16H3ZM7 6H8V18H7V6ZM4 6H6V18H4V6ZM10 6H12V18H10V6ZM17 6H18V18H17V6ZM19 6H20V18H19V6ZM13 6H16V18H13V6Z" />
    </SvgIcon>
  );
};
